import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/global.css';
import AdminApp from './components/AdminApp';

ReactDOM.createRoot(document.getElementById('root')).render(<AdminApp />);
